import c from '../../utils/tailwind-merge';
import { IconButton } from '../Button/IconButton';

type GalleryControlsProps = {
  currentSlide: number;
  totalSlides: number;
  nextSlide: () => void;
  previousSlide: () => void;
  previousAriaLabel: string;
  nextAriaLabel: string;
};

export const GalleryControls = ({
  currentSlide,
  totalSlides,
  nextSlide,
  previousSlide,
  previousAriaLabel,
  nextAriaLabel,
}: GalleryControlsProps) => {
  const buttonClassNames = `h-9 w-9 rounded-full focus-visible:bg-grey-200 focus-visible:outline-none`;
  const iconClassNames = `h-6 w-6 fill-grey-600 hover:fill-grey-800`;

  return (
    <div className="w-full bg-grey-100 px-2 py-2 md:rounded-b-lg lg:px-0 lg:py-0">
      <div className="bg-gray-100 mx-auto flex w-full items-center justify-between lg:w-fit">
        <IconButton
          iconName="CaretLeft"
          ariaLabel={previousAriaLabel}
          className={buttonClassNames}
          iconClassName={c(iconClassNames)}
          iconSize={24}
          testId="gallery-previous-button"
          onClick={previousSlide}
        />
        <span className="tiny-text mx-2 mt-px font-bold text-grey-600">
          {currentSlide + 1} / {totalSlides}
        </span>
        <IconButton
          iconName="CaretRight"
          ariaLabel={nextAriaLabel}
          className={buttonClassNames}
          iconClassName={c(iconClassNames)}
          iconSize={24}
          onClick={nextSlide}
          testId="gallery-next-button"
        />
      </div>
    </div>
  );
};
